import { type FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface InfoPageProps {
  title: string;
  message: ReactNode;
  illustration: ReactNode;
  actions?: ReactNode;
}

export const InfoPage: FC<InfoPageProps> = ({
  title,
  message,
  illustration,
  actions,
}) => (
  <Box
    sx={{
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      maxWidth: "100%",
      textAlign: "center",
    }}
  >
    {illustration}
    <Typography
      variant="h4"
      component="h1"
      sx={{
        color: ({ palette }) => palette.text.primary,
        fontWeight: 400,
        letterSpacing: 0,
        lineHeight: "100%",
        mt: "20px",
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="h5"
      component="p"
      sx={{
        color: ({ palette }) => palette.text.primary,
        fontWeight: 400,
        letterSpacing: 0,
        lineHeight: "100%",
        mt: "18px",
      }}
    >
      {message}
    </Typography>
    {actions && (
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          gap: 1,
          mt: "29px",
        }}
      >
        {actions}
      </Box>
    )}
  </Box>
);
